import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, reactive, ref, computed } from 'vue';
import { ModalToolbar } from 'md-editor-v3';
import type { Insert } from 'md-editor-v3';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import { ContentStoreState } from '@/stores/content.store';
import { Initiative } from '@/models/initiative.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkToolbar',
  props: {
  /**
   * `insert` will be automatically injected into the component by the editor
   */
  insert: {
    type: Function as PropType<Insert>,
    default: () => {
      //
    },
  },
},
  setup(__props) {

const data = reactive({
  modalVisible: false,
  modalFullscreen: false,
});

const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();

const initiatives = computed<Initiative[]>(() => store.state.cns.initiatives);

const props = __props;

const handler = (target: string) => {
  props.insert((selectedText) => {
    /**
     * targetValue    Content to be inserted
     * select         Automatically select content, default: true
     * deviationStart Start position of the selected content, default: 0
     * deviationEnd   End position of the selected content, default: 0
     */
    return {
      targetValue: `[${selectedText || 'description'}](${target})`,
      select: true,
      deviationStart: 0,
      deviationEnd: 0,
    };
  });

  data.modalVisible = false;
};

const chooseLink = () => {
  if (linkUrl.value !== '') {
    handler(linkUrl.value);
  }
};

const linkUrl = ref<string>('');

const tab = ref<string>('link');

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createBlock(_unref(ModalToolbar), {
    visible: data.modalVisible,
    isFullscreen: data.modalFullscreen,
    title: "media",
    modalTitle: "Insert Link",
    width: "600px",
    height: "800px",
    onOnClick: _cache[6] || (_cache[6] = ($event: any) => (data.modalVisible = true)),
    onOnClose: _cache[7] || (_cache[7] = ($event: any) => (data.modalVisible = false)),
    onOnAdjust: _cache[8] || (_cache[8] = ($event: any) => (data.modalFullscreen = !data.modalFullscreen))
  }, {
    trigger: _withCtx(() => _cache[19] || (_cache[19] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "lucide lucide-link-icon md-editor-icon"
      }, [
        _createElementVNode("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
        _createElementVNode("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
      ], -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        "fixed-tabs": "",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "link" }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Link")
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "initiative" }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Initiative Link")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, { value: "link" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Insert a link into the text", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("p", null, "Provide a url", -1)),
                  _createVNode(_component_v_text_field, {
                    label: "URL",
                    modelValue: linkUrl.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((linkUrl).value = $event)),
                    placeholder: "https://"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { col: "2" }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            type: "reset",
                            block: "",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (data.modalVisible = false))
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("Cancel")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            block: "",
                            type: "button",
                            onClick: chooseLink
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("Save")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { col: "2" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, { value: "initiative" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Link to an initiative", -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("p", null, "Choose the initiative", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: linkUrl.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((linkUrl).value = $event)),
                    label: "Initiative",
                    menuProps: { attach: true },
                    "hide-details": "auto",
                    items: initiatives.value.map((q) => ({ title: q.title, value: q }))
                  }, {
                    item: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "items"]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { col: "2" }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            type: "reset",
                            block: "",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (data.modalVisible = false))
                          }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode("Cancel")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            block: "",
                            type: "button",
                            onClick: chooseLink
                          }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("Save")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { col: "2" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["visible", "isFullscreen"]))
}
}

})